import { getIsMobileWidth } from '@elem/utils/devices';
import ModuleDesign from '../comps/ModuleDesign';
import BroadCompatibility from '../comps/BroadCompatibility';
import MaximizeEnergy from '../comps/MaximizeEnergy';
import ChargingTimes from '../comps/ChargingTimes';
import WhatInBox from '../comps/WhatInBox';
import Specs from '../comps/Specs';
import LightWeight from '../comps/Lightweight';
import AllWeather from '../comps/AllWeather';
import LongLasting from '../comps/LongLasting';
import PlugAndPlay from '../comps/PlugAndPlay';
import styles from './ProductContent.module.scss';
import EfScrollAni from '@/efscrollani';
import Banner from '../comps/Banner';
import Footnotes from '../comps/Footnotes';

export const PRODUCT_BASE = 'https://websiteoss.ecoflow.com/upload/image/1725595196999/%E7%99%BD%E5%BA%95%E5%9B%BE_%E5%9F%BA%E7%A1%80.png';
export const PRODUCT_TM = 'https://websiteoss.ecoflow.com/upload/image/1725595196761/%E7%99%BD%E5%BA%95%E5%9B%BE_TM.png';
export const PRODUCT_OTHER = 'https://websiteoss.ecoflow.com/upload/image/1725604441004/Lead-acid%2012V%20Battery.png';

export default function Teaser() {
    const isMobile = getIsMobileWidth();

    return (
        <div className={styles.teaser}>
            <Banner />
            <ModuleDesign />
            <LongLasting />
            <BroadCompatibility />
            <MaximizeEnergy />
            <AllWeather />
            <LightWeight />
            <PlugAndPlay />
            <ChargingTimes />
            <WhatInBox />
            <Specs />
            <Footnotes />
        </div>
    );
}
